module.exports = __webpack_public_path__ + "img/15.1b01db15.jpg";